"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _reactEmotion = require("react-emotion");

var _styleConsts = require("../utils/styleConsts");

var div =
/*#__PURE__*/
(0, _reactEmotion.css)("position:relative;");

var input = function input(theme) {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("height:", _styleConsts.height.medium, ";outline:none;&::placeholder{color:", theme.color.black3, ";}&:focus::placeholder{color:", theme.color.black3, ";}")
  );
};

var span = function span() {
  return (
    /*#__PURE__*/
    (0, _reactEmotion.css)("position:absolute;bottom:-24px;left:0;font-size:", _styleConsts.font.size.medium, ";")
  );
};

var _default = {
  div: div,
  input: input,
  span: span
};
exports.default = _default;